import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/basemap/update/basemap.update.mutation.gql"
import type {
  BasemapUpdateMutation,
  BasemapUpdateMutationVariables,
} from "@/v2-backoffice-client/basemap/update/__types__/basemap.update.mutation"

type Options = MutationHookOptions<
  BasemapUpdateMutation,
  BasemapUpdateMutationVariables
>

export function useBasemapUpdateMutation(options?: Options) {
  return useMutation<BasemapUpdateMutation, BasemapUpdateMutationVariables>(
    mutation,
    options,
  )
}
